import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav, Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLanguage = i18n.language === 'it' ? 'en' : 'it';
    i18n.changeLanguage(newLanguage);
    localStorage.setItem('i18nextLng', newLanguage);
  };

  return (
    <BootstrapNavbar expand="lg" className="py-3" style={{ backgroundColor: '#2c3e50' }}>
      <Container>
        <BootstrapNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <span className="logo-bg" style={{
            backgroundColor: 'rgba(248, 248, 248, 0.85)',
            width: '120px',
            height: '120px',
            borderRadius: '50%',
            backdropFilter: 'blur(4px)',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
          }}>
            <img
              src="https://res.cloudinary.com/dwc20azoo/image/upload/v1749056400/cogeis_bianco_xqtu32.png"
              alt="Cogeis Logo"
              height="50"
              style={{
                filter: 'brightness(1.2)'
              }}
            />
          </span>
        </BootstrapNavbar.Brand>
        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/progetti" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
              {t('projects')}
            </Nav.Link>
            <Nav.Link as={Link} to="/servizi" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
              {t('services')}
            </Nav.Link>
            <Nav.Link as={Link} to="/contatti" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
              {t('contact')}
            </Nav.Link>
            <Nav.Link as={Link} to="/login" style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase' }}>
              {t('admin')}
            </Nav.Link>
            <Button
              variant="outline-light"
              onClick={toggleLanguage}
              style={{ 
                fontFamily: 'Montserrat, sans-serif', 
                marginLeft: '10px',
                fontWeight: '600',
                letterSpacing: '1px',
                textTransform: 'uppercase'
              }}
            >
              {i18n.language === 'it' ? 'EN' : 'IT'}
            </Button>
          </Nav>
        </BootstrapNavbar.Collapse>
      </Container>
    </BootstrapNavbar>
  );
};

export default Navbar; 